module.exports = __webpack_public_path__ + "static/media/tiger-img.fc014c63.png";